module.exports = __webpack_public_path__ + "img/z_y.53f95064.png";